import { AppShell } from "./AppShell";

/** Layout for unauthenticated / public dashboard routes (e.g. /login). */
export function WebsiteLayout(): JSX.Element {
  return <AppShell />;
}
